export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/greenCheck.aba5c829.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};